"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _block_ai_learning = require("./block_ai_learning");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
module.exports = {
  getBlocks: function getBlocks() {
    var probabilityBlocks = (0, _block_ai_learning.createParamBlock)({
      type: 'logistic_regression',
      name: 'get_logistic_regression_probability',
      length: 6,
      createFunc: function createFunc(paramsKeyMap) {
        return /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(sprite, script) {
            var keys, predictKey, params, predict, predictResult, result;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  keys = Object.keys(paramsKeyMap);
                  predictKey = keys.pop();
                  params = keys.map(function (key) {
                    return script.getNumberValue(key, script);
                  });
                  predict = script.getStringField(predictKey, script);
                  _context.next = 1;
                  return Entry.aiLearning.predict(params);
                case 1:
                  predictResult = Entry.aiLearning.getPredictResult();
                  result = predictResult.find(function (x) {
                    return x.className === predict;
                  });
                  return _context.abrupt("return", (result === null || result === void 0 ? void 0 : result.probability) || 0);
                case 2:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function (_x, _x2) {
            return _ref.apply(this, arguments);
          };
        }();
      },
      params: [{
        type: 'DropdownDynamic',
        value: null,
        menuName: _block_ai_learning.DropDownDynamicGenerator.valueMap,
        needDeepCopy: true,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
        arrowColor: EntryStatic.colorSet.common.WHITE,
        defaultValue: function defaultValue(value, options) {
          if (options[0] && options[0][1]) {
            return options[0][1];
          }
          return value || 0;
        }
      }]
    });
    return _objectSpread(_objectSpread({}, probabilityBlocks), {}, {
      learning_title_logistic_regression: {
        skeleton: 'basic_text',
        color: EntryStatic.colorSet.common.TRANSPARENT,
        params: [{
          type: 'Text',
          text: Lang.template.learning_title_logistic_regression_str,
          color: EntryStatic.colorSet.common.TEXT,
          align: 'center'
        }],
        def: {
          type: 'learning_title_logistic_regression'
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_logistic_regression'],
        events: {}
      },
      set_logistic_regression_option: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.train_param_learningRate, 'learningRate'], [Lang.AiLearning.train_param_epochs, 'epochs'], [Lang.AiLearning.train_param_validationRate, 'validationRate']],
          value: 'learningRate',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Block',
          accept: 'string',
          defaultType: 'number'
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          type: 'set_logistic_regression_option'
        },
        pyHelpDef: {
          params: [],
          type: 'set_logistic_regression_option'
        },
        paramsKeyMap: {
          OPTION: 0,
          VALUE: 1
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_logistic_regression'],
        func: function func(sprite, script) {
          var option = script.getField('OPTION', script);
          var value = script.getNumberValue('VALUE', script);
          Entry.aiLearning.setTrainOption(option, parseFloat(value));
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      },
      set_logistic_regression_optimizer: {
        color: EntryStatic.colorSet.block["default"].AI_LEARNING,
        outerLine: EntryStatic.colorSet.block.darken.AI_LEARNING,
        skeleton: 'basic',
        statements: [],
        params: [{
          type: 'Dropdown',
          options: [[Lang.AiLearning.train_param_optimizer_adam, 'adam'], [Lang.AiLearning.train_param_optimizer_sgd, 'sgd']],
          value: 'adam',
          bgColor: EntryStatic.colorSet.block.darken.AI_LEARNING,
          arrowColor: EntryStatic.colorSet.common.WHITE
        }, {
          type: 'Indicator',
          img: 'block_icon/ai_utilize_icon.svg',
          size: 11
        }],
        events: {},
        def: {
          type: 'set_logistic_regression_optimizer'
        },
        pyHelpDef: {
          params: [],
          type: 'set_logistic_regression_optimizer'
        },
        paramsKeyMap: {
          OPTIMIZER: 0
        },
        "class": 'ai_learning',
        isNotFor: ['ai_learning_logistic_regression'],
        func: function func(sprite, script) {
          var optimizer = script.getField('OPTIMIZER', script);
          Entry.aiLearning.setTrainOption('optimizer', optimizer);
          return script.callReturn();
        },
        syntax: {
          js: [],
          py: []
        }
      }
    });
  }
};